import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Approach from "./pages/Approach";
import Insights from "./pages/Insights";
import InsightDetail from "./pages/InsightDetail";
import CaseStudyDetail from "./pages/CaseStudyDetail";
import TeamMember from "./pages/TeamMember";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import MemberLogin from "./pages/MemberLogin";
import MemberPortal from "./pages/MemberPortal";
import Library from "./pages/Library";
import RouteTracker from "./components/RouteTracker";
import AuthCallback from "./components/AuthCallback";
import { Toaster } from "./components/ui/toaster";

function AppRoutes() {
  const location = useLocation();
  // Detect the Emergent OAuth return synchronously during render — must
  // process the session_id BEFORE any auth-protected route runs.
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="services" element={<Services />} />
        <Route path="approach" element={<Approach />} />
        <Route path="insights" element={<Insights />} />
        <Route path="insights/:slug" element={<InsightDetail />} />
        <Route path="case-studies/:slug" element={<CaseStudyDetail />} />
        <Route path="team/:slug" element={<TeamMember />} />
        <Route path="contact" element={<Contact />} />
        <Route path="member-login" element={<MemberLogin />} />
        <Route path="member" element={<MemberPortal />} />
        <Route path="library" element={<Library />} />
        <Route path="admin" element={<Admin />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RouteTracker />
        <AppRoutes />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
